// Copyright (c) StrangeBee 2024

import { QueryKey, UseQueryResult } from 'react-query';
import client from '@Client';
import { useCallback } from 'react';
import { DescribeOutput, DescribeVersionsEnum } from 'thehive-sdk';
import { useGenericQuery } from './genericQueries';

export const useListAllFields = (version?: DescribeVersionsEnum): UseQueryResult<DescribeOutput, QueryKey> => {
    const fetchCallback = useCallback(() => client.DescribeController.get<DescribeOutput>(version), [version]);

    return useGenericQuery({ fetchCallback, key: ['describe-all', version], manual: true });
};
